export default __webpack_public_path__ + "static/media/Right.b25de644.dwg";